import React, { useState, useEffect } from 'react';
import './App.css';
import Landing from './pages/Landing';
import Examples from './pages/Examples';
import WorkHistory from './pages/WorkHistory';
import Bio from './pages/Bio';

function App() {
  const [activePage, setActivePage] = useState(() => localStorage.getItem('activePage') || 'landing');

  useEffect(() => {
    localStorage.setItem('activePage', activePage);
  }, [activePage]);

  return (
    <div className="App">
      {activePage === 'landing' && <Landing setActivePage={setActivePage}/>}
      {activePage === 'examples' && <Examples setActivePage={setActivePage}/>}
      {activePage === 'resume' && <WorkHistory setActivePage={setActivePage}/>}
      {activePage === 'bio' && <Bio setActivePage={setActivePage}/>}
    </div>
  );
}

export default App;
